import React from "react";
import { ICase, ISubCase } from "us.collection.transactions/interfaces";
import { appInsights } from "us.helper";
import { ITableCustomComponents } from "../Interfaces";
import { AdditionalReferenceRenderer } from "../Components";

export const getAdditionalReferenceTableRenderItems = (
    additionalReference: keyof ISubCase
): ITableCustomComponents => {
    try {
        return {
            customSorter: (a: any, b: any) => a?.localeCompare(b),
            customRenderParent: (text: any, record: ICase, index: number) => (
                <AdditionalReferenceRenderer
                    renderingRecord={record}
                    additionalReferenceItem={additionalReference}
                />
            ),
            customRenderChild: (text: any, record: ISubCase, index: number) => (
                <AdditionalReferenceRenderer
                    renderingRecord={record}
                    additionalReferenceItem={additionalReference}
                />
            ),
        };
    } catch (error) {
        appInsights.trackException(
            `Error in case and subcases getTableRenderItems function. - ${error}`
        );

        return {
            customSorter: (a: any, b: any) => a - b,
            customRenderParent: (text: any, record: ICase, index: number) => ({
                children: <></>,
                key: index,
                props: { colSpan: 1 },
            }),
            customRenderChild: (text: any, record: ISubCase, index: number) => ({
                children: <></>,
                key: index,
                props: { colSpan: 1 },
            }),
        };
    }
};
